import angular from "angular";

angular
    .module('mobiusControl.mobiusNotification', [])
    .service('MobiusNotification', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/mobius/notifications';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.store = function (params) {
            return $http.post(uri(), params);
        };

        this.update = function (id, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(id), params);
        };

        this.destroy = function (id) {
            return $http.post(uri(id), {'_method': 'DELETE'})
        };

    }]);

export default 'mobiusControl.mobiusNotification';


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/mobius-notification.js